import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { SearchInput } from '@gem/ui-kit';

import { ChipsWithAvatar } from 'APP/components/ChipsWithAvatar/ChipsWithAvatar';

import styles from './SelectContact.styles.m.css';
import { ISelectContactsProps } from './SelectContacts.types';
import { Users } from './Users/Users';
import { useSelectContactsPresenter } from './presenter/SelectContacts.presenter';

export const SelectContacts: FC<ISelectContactsProps> = observer(
  ({
    isLoading = false,
    contacts,
    setSelectedIds,
    selectedContactsIds,
    groupId = '',
    children,
    targetGroupType,
    hasMore = false,
    loadMore,
  }) => {
    const { myContactsPresenter, extendedUsersPresenter, presenter } = useSelectContactsPresenter({
      selectedContactsIds,
      setSelectedIds,
      contacts,
      isLoading,
      groupId,
      targetGroupType,
      hasMore,
      loadMore,
    });

    const { t } = useTranslation();

    return (
      <>
        <SearchInput
          className={styles.search}
          onChange={presenter.onSearchValueChange}
          value={presenter.searchValue}
          placeholder={t('main_menu_search_note')}
        />
        <ChipsWithAvatar
          chips={presenter.chips}
          onRemove={presenter.removeChips}
        />
        {children}
        <Users
          selectContactsPresenter={presenter}
          myContactsPresenter={myContactsPresenter}
          extendedUsersPresenter={extendedUsersPresenter}
        />
      </>
    );
  }
);
